var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 53 53"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34.474 26.423 18.17-18.527L44.594 0l-18.17 18.527L7.895.357 0 8.406l18.527 18.17L.357 45.105 8.407 53l18.17-18.527 18.528 18.17L53 44.594l-18.527-18.17Z",
    clipRule: "evenodd"
  })));
};
export default SvgError;